import { useMemo } from 'react';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { FamilyDto, OneRosterFamilyDto } from '@families-link/shared';
import { Typography } from '@mui/material';
import { tableCellTypographyOverflowStyles } from '../../../_core/styles';
import { mergeSx } from 'merge-sx';
import { OneRosterFamiliesTableHandlers } from '../../components/families-table';
import { OneRosterFamiliesTableActions } from '../../components/families-table/oneroster-families-table-action.component';
const helper = createColumnHelper<OneRosterFamilyDto>();

export function useOneRosterFamiliesTableColumns(
	handlers: OneRosterFamiliesTableHandlers
): ColumnDef<OneRosterFamilyDto, string>[] {
	const { onView } = handlers;

	const [t] = useTranslation();

	const result = useMemo(
		() => [
			helper.accessor('familyName', {
				header: 'Family name',
				meta: {
					flex: 1,
					useCustomOverflowContainer: true,
				},
				enableSorting: false,
				cell: ({ getValue }) => {
					const fullName = getValue();

					return (
						<Typography data-overflow="true" sx={mergeSx({ fontWeight: 500 }, tableCellTypographyOverflowStyles)}>
							{fullName ? fullName : '-'}
						</Typography>
					);
				},
			}) as ColumnDef<OneRosterFamilyDto, string>,
			helper.accessor('studentPhoneNumber', {
				header: 'Phone number',
				meta: {
					flex: 1,
				},
				enableSorting: false,
			}) as ColumnDef<OneRosterFamilyDto, string>,
			helper.accessor('studentEmail', {
				header: 'Email',
				meta: {
					flex: 1,
				},
				enableSorting: false,
				cell: ({ getValue }) => (
					<Typography data-overflow="true" sx={mergeSx({ fontWeight: 500 }, tableCellTypographyOverflowStyles)}>
						{getValue() ? getValue() : '-'}
					</Typography>
				),
			}) as ColumnDef<OneRosterFamilyDto, string>,
			helper.accessor('studentFullName', {
				header: 'Student name',
				meta: {
					flex: 1,
					useCustomOverflowContainer: true,
				},
				enableSorting: false,
				cell: ({ getValue }) => {
					const fullName = getValue();

					return (
						<Typography data-overflow="true" sx={mergeSx({ fontWeight: 500 }, tableCellTypographyOverflowStyles)}>
							{fullName ? fullName : '-'}
						</Typography>
					);
				},
			}) as ColumnDef<OneRosterFamilyDto, string>,

			helper.accessor('studentId', {
				header: 'Student id',
				meta: {
					flex: 1,
				},
				enableSorting: false,
			}) as ColumnDef<OneRosterFamilyDto, string>,
			helper.accessor('preferedLanguage', {
				header: 'Language',
				meta: {
					flex: 1,
				},
				enableSorting: false,
			}) as ColumnDef<OneRosterFamilyDto, string>,
			helper.display({
				meta: {
					flex: 0.3,
				},
				id: 'actions',
				cell: (props) => <OneRosterFamiliesTableActions oneRosterFamily={props.row.original} onView={onView} />,
			}) as ColumnDef<OneRosterFamilyDto>,
			helper.display({
				id: 'select',

				cell: ({ row }) => (
					<input
						type="checkbox"
						checked={row.getIsSelected()}
						onChange={() => {
							row.toggleSelected();
						}}
					/>
				),
				meta: {
					flex: 0.2,
				},
			}) as ColumnDef<OneRosterFamilyDto>,
		],
		[t, onView]
	);

	return result;
}
